module.exports = __webpack_public_path__ + "static/media/japan.b58300d8.svg";